module.exports = __webpack_public_path__ + "static/media/cmp_data_model.87fafcbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/cmp_data_model.png
// module id = 987
// module chunks = 0